import React from "react";
import moment from "moment";
import { Space } from "antd";
import {
  AxTimePicker,
  AxTimeRangePicker,
  AxDivider,
  AxButton,
} from "@dynata/axiom3";

class Timepicker extends React.Component {
  render() {
    return (
      <div className="section" id="timepicker">
        <h3>Time Picker</h3>
        <Space direction="vertical" size="middle">
          <p>
            By clicking the input box, you can select a time from a popup panel.
          </p>

          <Space size="large" direction="vertical">
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/time-picker/#API"
                >
                  https://ant.design/components/time-picker/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Size of the TimePicker, default is medium</td>
                  <td>small | large</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>allowClear</td>
                  <td>Whether to show clear button, default is true</td>
                  <td>boolean</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>disabled</td>
                  <td>
                    Determine whether the TimePicker is disabled, default is
                    false
                  </td>
                  <td>boolean</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>value, defaultValue</td>
                  <td>moment</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>allowClear</td>
                  <td>Whether allow clearing text</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>autoFocus</td>
                  <td>If get focus when component mounted</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>bordered</td>
                  <td>Whether has border style</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>className</td>
                  <td>The className of picker</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>clearIcon</td>
                  <td>The custom clear icon</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>clearText</td>
                  <td>The clear tooltip of icon</td>
                  <td>string</td>
                  <td>clear</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultValue</td>
                  <td>To set default time</td>
                  <td>
                    <a href="http://momentjs.com/">moment</a>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>Determine whether the TimePicker is disabled</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabledTime</td>
                  <td>To specify the time that cannot be selected</td>
                  <td>
                    <a href="#DisabledTime">DisabledTime</a>
                  </td>
                  <td>-</td>
                  <td>4.19.0</td>
                </tr>
                <tr>
                  <td>format</td>
                  <td>To set the time format</td>
                  <td>string</td>
                  <td>
                    <code>HH:mm:ss</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>getPopupContainer</td>
                  <td>
                    To set the container of the floating layer, while the
                    default is to create a div element in body
                  </td>
                  <td>function(trigger)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>hideDisabledOptions</td>
                  <td>Whether hide the options that can not be selected</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>hourStep</td>
                  <td>Interval between hours in picker</td>
                  <td>number</td>
                  <td>1</td>
                  <td></td>
                </tr>
                <tr>
                  <td>inputReadOnly</td>
                  <td>
                    Set the <code>readonly</code> attribute of the input tag
                    (avoids virtual keyboard on touch devices)
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>minuteStep</td>
                  <td>Interval between minutes in picker</td>
                  <td>number</td>
                  <td>1</td>
                  <td></td>
                </tr>
                <tr>
                  <td>open</td>
                  <td>Whether to popup panel</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>placeholder</td>
                  <td>Display when there's no value</td>
                  <td>string | [string, string]</td>
                  <td>
                    <code>Select a time</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>placement</td>
                  <td>The position where the selection box pops up</td>
                  <td>
                    <code>bottomLeft</code> <code>bottomRight</code>{" "}
                    <code>topLeft</code> <code>topRight</code>
                  </td>
                  <td>bottomLeft</td>
                  <td></td>
                </tr>
                <tr>
                  <td>popupClassName</td>
                  <td>The className of panel</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>popupStyle</td>
                  <td>The style of panel</td>
                  <td>CSSProperties</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>renderExtraFooter</td>
                  <td>
                    Called from time picker panel to render some addon to its
                    bottom
                  </td>
                  <td>() =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>secondStep</td>
                  <td>Interval between seconds in picker</td>
                  <td>number</td>
                  <td>1</td>
                  <td></td>
                </tr>
                <tr>
                  <td>showNow</td>
                  <td>
                    Whether to show <code>Now</code> button on panel
                  </td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>4.4.0</td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>Set validation status</td>
                  <td>'error' | 'warning' | 'success' | 'validating'</td>
                  <td>-</td>
                  <td>4.19.0</td>
                </tr>
                <tr>
                  <td>suffixIcon</td>
                  <td>The custom suffix icon</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>use12Hours</td>
                  <td>
                    Display as 12 hours format, with default format{" "}
                    <code>h:mm:ss a</code>
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>To set time</td>
                  <td>
                    <a href="http://momentjs.com/">moment</a>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>
                    A callback function, can be executed when the selected time
                    is changing
                  </td>
                  <td>function(time: moment, timeString: string): void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onOpenChange</td>
                  <td>
                    A callback function which will be called while panel
                    opening/closing
                  </td>
                  <td>(open: boolean) =&gt; void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onSelect</td>
                  <td>
                    A callback function, executes when a value is selected
                  </td>
                  <td>function(time: moment): void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/time-picker/#API"
                      >
                        {`<TimePicker />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxTimePicker defaultValue={moment("12:08:23", "HH:mm:ss")} size="small" />
<AxTimePicker defaultValue={moment("12:08:23", "HH:mm:ss")} />
<AxTimePicker defaultValue={moment("12:08:23", "HH:mm:ss")} disabled />
<AxTimePicker defaultValue={moment("12:08:23", "HH:mm:ss")} size="large" />`}</pre>
            <AxTimePicker
              defaultValue={moment("12:08:23", "HH:mm:ss")}
              size="small"
            />
            <AxTimePicker defaultValue={moment("12:08:23", "HH:mm:ss")} />
            <AxTimePicker
              defaultValue={moment("12:08:23", "HH:mm:ss")}
              disabled
            />
            <AxTimePicker
              defaultValue={moment("12:08:23", "HH:mm:ss")}
              size="large"
            />
          </Space>

          <AxDivider orientation="left" plain>
            Range Picker
          </AxDivider>

          <Space size="large" direction="vertical">
            <pre>{`<AxTimeRangePicker size="small" />
<AxTimeRangePicker />
<AxTimeRangePicker disabled />
<AxTimeRangePicker size="large" />`}</pre>
            <AxTimeRangePicker size="small" />
            <AxTimeRangePicker />
            <AxTimeRangePicker disabled />
            <AxTimeRangePicker size="large" />
          </Space>
        </Space>
      </div>
    );
  }
}
export default Timepicker;
